import { render } from "./DemographicsForm.vue?vue&type=template&id=04f50e8e&scoped=true"
import script from "./DemographicsForm.vue?vue&type=script&lang=js"
export * from "./DemographicsForm.vue?vue&type=script&lang=js"

import "./DemographicsForm.vue?vue&type=style&index=0&id=04f50e8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f50e8e"]])

export default __exports__